"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const Group_1 = __importDefault(require("./Group"));
const groupAndOrderBy_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/groupAndOrderBy"));
const trans_1 = require("@common/tsutils/trans");
class GroupConfigInstance {
    constructor(config) {
        // Extra options
        this.num_of_groups = 2; // Default value
        this.direction = 'asc';
        this.config = config;
    }
    clone() {
        const clon = new GroupConfigInstance(this.config);
        clon.num_of_groups = this.num_of_groups;
        clon.direction = this.direction;
        return clon;
    }
    group(samples, parent = null) {
        let maxGroups = null;
        if (this.config.has_extra_num_of_groups) {
            maxGroups = this.num_of_groups;
        }
        const genericGroups = (0, groupAndOrderBy_1.default)(samples, this.config.type, s => s.retrieveValueForFilterOrGroup(this.config), this.direction, maxGroups);
        return genericGroups.map(generic => {
            let name = '';
            if (generic.option === null) {
                name = (0, trans_1.trans)('heatmap.type_options.none');
            }
            else if (generic.type === 'single') {
                switch (this.config.type) {
                    case 'date':
                        name = (0, moment_1.default)(generic.option).format('YYYY-MM-DD');
                        break;
                    case 'boolean':
                        name = generic.option ? this.config.name : 'No ' + this.config.name;
                        break;
                    case 'list':
                        name = this.config.option_label_fn(generic.option + '');
                        break;
                    default:
                        name = generic.option + '';
                }
            }
            else {
                switch (this.config.type) {
                    case 'date':
                        name = (0, moment_1.default)(generic.option).format('YYYY-MM-DD');
                        name += ' to ';
                        name += (0, moment_1.default)(generic.optionB).format('YYYY-MM-DD');
                        break;
                    case 'list':
                        name = this.config.option_label_fn(generic.option + '') + '-' + this.config.option_label_fn(generic.optionB + '');
                        break;
                    default:
                        name = generic.option + '-' + generic.optionB;
                }
            }
            const group = new Group_1.default(name, parent);
            group.samples = generic.items;
            return group;
        });
    }
    toConfiguration() {
        return {
            config_name: this.config.name,
            num_of_groups: this.num_of_groups,
            direction: this.direction,
        };
    }
}
exports.default = GroupConfigInstance;
